module.exports = __webpack_public_path__ + "static/media/faild.0385df0b.svg";